import server from 'utils/request';
import jsonp from 'components/jsonp';
import { post } from 'utils/request';

/**
 * 枚举接口
 * @param enumKey
 */
export function getEnumDict(enumKey) {
  var params = {
    enumKey
  }
  return server({
    url: '/common/getEnumDict',
    method: 'get',
    params
  })
}

/**
 * 字典接口
 * @param enumKey
 */
export function getDic(data) {
  return server({
    url: '/common/getDictByGroupParent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取案件详情
 * @param enumKey
 */
export function getCaseDetails(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取仲裁通知内容
 * @param letterId
 */
export function letter(letterId) {
  var data = {
    letterId
  };
  return server({
    url: 'case/letter/view',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 区块链校验
 * @param caseTempNo
 */
export function check(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/bcos/evidence',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取送达详情
 * @param caseTempNo
 */
export function sendDetail(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/send/detail',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 确认立案送达
 * @param data
 */
export function sendPlace(data) {
  return server({
    url: 'case/send/placeSend',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取答辩状内容
 * @param replyId
 */
export function getReply(replyId) {
  var params = {
    replyId
  };
  return server({
    url: '	/case/reply/view',
    method: 'get',
    params
  })
}


/**
 *  检查文件是否存在
 * @param filepath
 */
export function download(filepath) {
  var params = {
    filepath
  };
  return server({
    url: '/common/file/check',
    method: 'get',
    params
  })
}

/**
 * 下载接口
 * @param filepath
 */
export function downloadFile(filepath) {
  var params = {
    filepath
  };
  return server({
    url: '/common/file/download',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 * 下载接口
 * @param fileNo
 */
export function downloadFileNo(fileNo) {
  var params = {
    fileNo
  };
  return server({
    url: 'common/file/download/fileNo',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 * 下载仲裁员声明书
 * @param filepath
 */
export function arbStatement(caseTempNo) {
  var params = {
    caseTempNo
  };
  return server({
    url: '/common/download/arbStatement',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 * 下载裁决书
 * @param caseTempNo
 */
export function downloadDraft(caseTempNo) {
  var params = {
    caseTempNo
  };
  return server({
    url: '/case/judge/download/check',
    method: 'get',
    params
  })
}
/**
 * 进入笔录
 * @param data
 */
export function enterRecode(data) {
  return server({
    url: '/ebcase/trial/text',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 更新笔录
 * @param data
 */
export function updateRecode(data) {
  return server({
    url: '/ebcase/update/recode',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })

}
/**
 * 下载笔录接口
 * @param caseTempNo
 */
export function downloadRecode(caseTempNo) {
  var params = {
    caseTempNo
  };
  return server({
    url: '/ebcase/download',
    method: 'get',
    params
  })
}

/**
 * 审核 仲裁员回避审核、管辖异议审核、反请求审核
 * @param data
 */
export function powerDetails(data) {
  return server({
    url: '/case/power/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 审核 决定书预览
 * @param data
 */
export function powerPreview(data) {
  return server({
    url: 'case/power/preview',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 *  获取审核步骤
 * @param data
 * 1:仲裁员回避2：管辖异议3：反请求4：裁决书审核
 */
export function step(data) {
  return server({
    url: '/case/judge/step',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 *  获取审核步骤
 * @param data
 * 1:仲裁员回避2：管辖异议3：反请求4：裁决书审核
 */
export function notices(data) {
  return server({
    url: '/case/letter/notices',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * sso登录
 * @param data
 */
export function loginSso(data) {
  return server({
    url: '/sys/loginSso',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        bodyFormData.append(it, data[it])
      }
      return bodyFormData
    }]
  })
}

/**
 * 验证是否登录
 */

export async function checkLogin() {
  var url = process.env.SSO_URL + '/getSsoToken';
  console.log(process.env)
  const options = { param: 'jsonpCallback', timeout: 5000 }
  var data = {
    title: '没有登录2'
  };
  var flag = false;
  try {
    var value = await jsonp(url, {}, options)
  } catch (err) {
    value = '';
    console.log(err);
  }
  if (value) {
    console.log(value)
    data = await loginSso({ ssoToken: value })
  }
  return new Promise((resolve, reject) => {
    resolve(data)
  });
}


/**
 * 初检
 * @param data
 */
export function caseCheck(data) {
  return server({
    url: '/case/check',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        bodyFormData.append(it, data[it])
      }
      return bodyFormData
    }]
  })
}

/**
 *  站内信消息列表（未读）
 * @param data
 */
export function unReadList(data) {
  return server({
    url: '/message/unRead',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 *  站内信消息列表(已读)
 * @param data
 */
export function readList(data) {
  return server({
    url: '/message/hadRead',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 *  站内信消息 （标记已读）
 * @param data
 */
export function read(params) {
  return server({
    url: '/message/markAsRead',
    method: 'get',
    params
  })
}
/**
 * 庭审排期   获取仲裁庭相关信息
 * @param data
 */
export function trial_house(data) {
  return server({
    url: '/ebcase/trial/house',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })

}
/**
 * 进入庭审
 * @param data
 */
export function entert_trial(data) {
  return server({
    url: '/ebcase/trial/page',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 庭审排期
 * @param data
 */
export function trial_sheduling(data) {
  return server({
    url: '/ebcase/trial/sheduling',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })

}
/**
 * 取消排期
 * @param data
 */
export function cancel_scheduling(data) {
  return server({
    url: '/ebcase/trial/scheduling/cancel',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 审理记录
 * @param data
 */
export function trialList(data) {
  return server({
    url: '/ebcase/trial/list',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 特殊流程审核文本
 * @param data
 */
export function showContent(data) {
  return server({
    url: '/case/power/showContent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 重新发送邮件
 * @param data
 */
export function againSendEmail(data) {
  return server({
    url: '/case/againSendEmail',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 邮件清单
 * @param data
 */
export function emailDetails(data) {
  return server({
    url: '/case/emailDetails',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 获取编辑邮件内容
 * @param letterId
 */
export function emailContent(letterId) {
  var data = {
    letterId
  };
  return server({
    url: 'case/emailContent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 邮件预览
 * @param data
 */
export function letterPreview(data) {
  return server({
    url: 'case/letter/preview',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 短信发送接口
 * @param data
 */
export function againSendSms(data) {
  return server({
    url: 'case/againSendSms',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 1.2 文件上传
 * @param data
 */
export function upload(data) {
  return server({
    url: '/common/file/upload',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js